// extracted by mini-css-extract-plugin
module.exports = {"errorText":"_2_KUZ"};